const appBaseUrl = window.location.hostname === 'localhost' 
    ? `http://${window.location.host}/` 
    : `https://${window.rsvDomain}/`;

export default appBaseUrl;
